import { PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import { Button } from '@/components/ui/daisy';
import useFormList from '@/data/hook/shared/useFormList';

import LessonPlanInlineForm from './LessonPlanInlineForm';

type CreateLessonPlanData = {
  name: string;
};

type LessonPlanFormListProps = {
  onSubmit: (data: CreateLessonPlanData) => void;
  isLoading: boolean;
};

export default function LessonPlanFormList({
  onSubmit,
  isLoading,
}: LessonPlanFormListProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.lessonPlansTab',
  });
  const { openForms, addForm, removeForm, handleFormSubmit } =
    useFormList<CreateLessonPlanData>({ onSubmit });

  return (
    <div className="flex flex-col gap-6">
      {openForms.map(formId => (
        <LessonPlanInlineForm
          key={formId}
          onSubmit={handleFormSubmit(formId)}
          onCancel={() => removeForm(formId)}
          isLoading={isLoading}
        />
      ))}
      <FieldsetContainer>
        <Button size="md" onClick={addForm} className="bg-base-300">
          <PlusIcon className="w-4 h-4" />
          {t('addLessonPlan')}
        </Button>
      </FieldsetContainer>
    </div>
  );
}
